import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetLeaf: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17 8c0 8-6 13-11 13m0 0C12 21 20 14 20 4c-6 0-14 4-14 12" />
      </svg>
    </div>
  );
};

export default WidgetLeaf;
